export enum CardZonesEnum {
  internal = 0,
  external = 1,
}
